function replaceViews(content) {
	const html = document.createRange().createContextualFragment(content);
	const title = html.querySelector('title').innerText;
	const containers = html.querySelectorAll('[data-async-view]');

	[].forEach.call(containers, (container) => {
		const currentContainer = document.getElementById(container.id);

		if (!currentContainer) {
			return;
		}

		currentContainer.innerHTML = container.innerHTML;
	});

	document.title = title;
}

function reloadView(url) {
	fetch(url)
		.then((r) => r.text())
		.then(replaceViews);
}

function delegate(e) {
	const el = e.target.closest('[data-async]');

	if (!el) {
		return;
	}

	const parent = el.closest('[data-async-view]');

	if (!parent) {
		return;
	}

	e.preventDefault();

	window.history.pushState({}, null, el.href);

	reloadView(el.href);
}

function onStateChange() {
	reloadView(document.location);
}

document.body.addEventListener('click', delegate);

window.addEventListener('popstate', onStateChange);
